/*
 * DOM utilities for the vehicle picker drawer: keep Tab inside the open dialog, lock page scroll
 * behind it, and fill the phone <select>s. Kept apart so seatfit-vehicle-picker.js stays about the
 * picking flow. Loaded `defer` by sections/seatfit-vehicle-picker.liquid before that script.
 */
(function () {
  'use strict';
  if (window.SeatFitPickerDom) return;

  var FOCUSABLE = 'button:not([disabled]), select:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';

  // Only controls that are rendered count: desktop hides the <select>s, phones hide the lists.
  function focusables(container) {
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
      return el.getClientRects().length > 0;
    });
  }

  function isShown(el) { return !!el && el.getClientRects().length > 0; }

  // Wraps Tab / Shift+Tab around the dialog; the dialog itself (tabindex=-1) counts as "before first".
  function trapTab(e, container) {
    var list = focusables(container);
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0];
    var last = list[list.length - 1];
    var a = document.activeElement;
    if (e.shiftKey && (a === first || a === container)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }

  // The scrollbar width goes into a CSS variable so the page behind does not jump sideways.
  function lockScroll(on) {
    var html = document.documentElement;
    if (on) {
      html.style.setProperty('--sf-vp-sbw', Math.max(0, window.innerWidth - html.clientWidth) + 'px');
      html.classList.add('sf-vp-locked');
    } else {
      html.classList.remove('sf-vp-locked');
    }
  }

  // f = { native, ph (cloned placeholder option), sig }. Rebuilds the options only when the list
  // changed, so an open OS wheel is not reset by an unrelated re-render.
  function syncSelect(f, options, value, enabled, emptyLabel) {
    var sel = f.native;
    if (!sel) return;
    var sig = options.map(function (o) { return o.value; }).join('|');
    if (sig !== f.sig && f.key !== 'type') {
      f.sig = sig;
      sel.textContent = '';
      if (f.ph) sel.appendChild(f.ph.cloneNode(true));
      if (!options.length && emptyLabel) {
        var none = new Option(emptyLabel, '__none'); // the competitor's "No available items" row
        none.disabled = true;
        sel.appendChild(none);
      }
      options.forEach(function (o) { sel.appendChild(new Option(o.label, o.value)); });
    }
    sel.disabled = !enabled;
    sel.value = value || (f.key === 'type' && sel.options[0] ? sel.options[0].value : '');
  }

  // Wires every .sf-vp__field: a desktop combobox and a phone <select>, both reporting to onChoose.
  function collectFields(root, Combo, onChoose) {
    var fields = {};
    root.querySelectorAll('.sf-vp__field').forEach(function (el) {
      var key = el.getAttribute('data-key');
      var native = el.querySelector('.sf-vp__native');
      var first = native && native.options[0];
      var f = { key: key, el: el, native: native, sig: null, ph: first ? first.cloneNode(true) : null };
      // Type lists the products Liquid printed (snippets/seatfit-type-options); they never change on the page.
      f.typeOptions = key === 'type' && first ? Array.prototype.map.call(native.options, function (o) {
        return { value: o.value, label: o.text };
      }) : null;
      f.combo = new Combo(el, function (v) { onChoose(key, v, true); });
      if (native) native.addEventListener('change', function () { onChoose(key, native.value || null, false); });
      fields[key] = f;
    });
    return fields;
  }

  // st = one entry of SeatFitPickerLists.fieldStates(): {options, value, ok, state}.
  function renderField(f, st, emptyLabel) {
    f.el.setAttribute('data-state', st.state);
    f.combo.btn.disabled = !st.ok;
    f.combo.setOptions(st.options, st.value, emptyLabel);
    syncSelect(f, st.options, st.value, st.ok, emptyLabel);
  }

  // Desktop keyboard flow: after a pick, focus the field that now needs a value, or GO when all are
  // set. Phones keep focus where it is; jumping between OS wheels would be disorienting.
  function focusNext(fields, keys, afterKey, goBtn) {
    var desktop = keys.some(function (k) { return fields[k] && isShown(fields[k].combo.btn); });
    if (!desktop) return;
    for (var i = afterKey ? keys.indexOf(afterKey) + 1 : 0; i < keys.length; i++) {
      var f = fields[keys[i]];
      if (!f || f.el.getAttribute('data-state') === 'done') continue;
      if (!f.combo.btn.disabled) f.combo.btn.focus();
      return;
    }
    if (goBtn && !goBtn.disabled) goBtn.focus();
  }

  window.SeatFitPickerDom = {
    focusables: focusables, isShown: isShown, trapTab: trapTab, lockScroll: lockScroll,
    syncSelect: syncSelect, collectFields: collectFields, renderField: renderField, focusNext: focusNext
  };
})();
